// ClientAlias.jsx

// Components
import TextEditor from '@/components/data/common/text/TextEditor';

// Services
import { updateClientAlias, deleteClientAlias } from '@/services/schedulingService';

const ClientAlias = ({ clientCode, clientAlias }) => {
  async function deleteAlias() {
    await deleteClientAlias(clientCode);
  }

  async function updateAlias(alias) {
    await updateClientAlias(clientCode, alias);
  }

  return <TextEditor value={clientAlias} updateText={updateAlias} deleteText={deleteAlias}></TextEditor>;
};

export default ClientAlias;
